import { RestApiResponse } from '../../common/rest-api.response';
export class NomenclatureTypeFormulaVariablesGetResponse extends RestApiResponse {
    public variableNames: string[];

    constructor(data?: Partial<NomenclatureTypeFormulaVariablesGetResponse>) {
        super(data);
        this.variableNames = data?.variableNames;
    }
}
